import { atom } from "recoil"

export const planMigrateFlag = atom<boolean>({
  key: "atoms/planMigrateFlag",
  default: false,
})
